import {Component, Input, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import { AuthenticationService } from '../../authentication/authentication.service';
import { I18nService } from '../../i18n.service';
import {UtilityService} from '../../utils.service';
import {DomainService} from '@app/core/domain/domain.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input()
  hideSubmenu: boolean;

  @Input()
  hideUser = false;

  @Input()
  leftText: string;
  hamburgerActived: any = false;
  hideHamburger: any = true;
  barBackground: string;
  barTextColor: string;
  isShoppingDomain = true;

  constructor(private router: Router,
              private authenticationService: AuthenticationService,
              private util: UtilityService,
              private i18nService: I18nService,
              private domainService: DomainService) {
    this.isShoppingDomain = domainService.isShoppingDomain();

    util.getBarBackground().subscribe((color) => {
      this.barBackground = '#' + color;
    });

    util.getBarTetColor().subscribe((color) => {
      this.barTextColor = '#' + color;
    });

    util.isMenuOpened().subscribe((menuOpened) => {
      this.hamburgerActived = menuOpened;
    });

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd ) {
        if (event.url !== '/login' && event.url !== '/' && event.url !== '/home') {
          this.hideHamburger = false;
        }
        console.log('current url', event.url);
      }
    });
  }

  ngOnInit() { }

  toggleMenu() {
    this.util.toggleMenu();
  }

  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  logout() {
    const logoutFn = this.authenticationService.logout();
    logoutFn.subscribe(() => this.router.navigate(['/login'], { replaceUrl: true }),  () => {
      this.router.navigate(['/login'], { replaceUrl: true });
    });
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  get username(): string | null {
    const credentials = this.authenticationService.credentials;
    return credentials ? credentials.username : null;
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/shell/header/header.component.ts